import onGetCarePlanMedications from './onGetCarePlanMedications';
import onCreateCarePlanMedications from './onCreateCarePlanMedications';
import onUpdateCarePlanMedication from './onUpdateCarePlanMedication';
import onRemoveCarePlanMedication from './onRemoveCarePlanMedication';

export default {
  onGetCarePlanMedications,
  onCreateCarePlanMedications,
  onUpdateCarePlanMedication,
  onRemoveCarePlanMedication,
};
